var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('PageIntro',{attrs:{"title":_vm.$t('pages.registration.title'),"subtitle":_vm.$t('pages.registration.subtitle')}})],1),_vm._v(" "),_c('RegistrationStepperSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }